import { render, staticRenderFns } from "./mediationRules.vue?vue&type=template&id=54c3a863&scoped=true&"
import script from "./mediationRules.vue?vue&type=script&lang=js&"
export * from "./mediationRules.vue?vue&type=script&lang=js&"
import style0 from "./mediationRules.vue?vue&type=style&index=0&id=54c3a863&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3a863",
  null
  
)

export default component.exports